import { render, staticRenderFns } from "./IndexReconsulta.vue?vue&type=template&id=107469cd&"
import script from "./IndexReconsulta.vue?vue&type=script&lang=js&"
export * from "./IndexReconsulta.vue?vue&type=script&lang=js&"
import style0 from "./IndexReconsulta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports